// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--cIk5r";
export var link = "Footer-module--link--4Nj1M";
export var linkVertical = "Footer-module--link--vertical--Nf2-T";
export var logoAndTerms = "Footer-module--logoAndTerms--1KK3g";
export var outerContainer = "Footer-module--outer-container--fJVnN";
export var wysiwygContent = "Footer-module--wysiwyg-content--ZZoDq";